import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=49c67b5c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c67b5c')) {
      api.createRecord('49c67b5c', component.options)
    } else {
      api.reload('49c67b5c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=49c67b5c&", function () {
      api.rerender('49c67b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2e2SgEypq8J/JS/comp/ErrorMessage.vue"
export default component.exports